import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  vendorID: 0,
  vendorContacts: [],
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'firstName',
      label: 'First Name',
      aria: 'First Name',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'lastName',
      label: 'Last Name',
      aria: 'Last Name',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'emailAddress',
      label: 'E-mail',
      aria: 'E-mail',
      width: '20%',
      sortable: true,
      searchable: true
    },
    {
      field: 'phone',
      label: 'Phone',
      aria: 'Phone',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'workPhone',
      label: 'Work Phone',
      aria: 'Work Phone',
      width: '10%',
      sortable: true,
      searchable: true
    },
    {
      field: 'cellPhone',
      label: 'Cell Phone',
      aria: 'Cell Phone',
      width: '10%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
